/**
 * Fill-ins for the few recent JavaScript features this site or its libraries use that its oldest supported browsers
 * (Chrome 109, Safari 15.4) lack. Each is installed only where the browser has none. The page loads this first, and so
 * do the workers (src/pdf/pdf.worker.ts, src/pdf/preparation/worker.ts). tests/e2e/old-browsers.mjs registers in those
 * browsers to find more.
 */

// Safari 17.4. PDF.js calls it throughout.
if (!('withResolvers' in Promise)) {
  Object.defineProperty(Promise, 'withResolvers', { configurable: true, writable: true, value: function withResolvers<T>(this: PromiseConstructor) {
    let resolve!: (value: T | PromiseLike<T>) => void, reject!: (reason?: unknown) => void;
    const promise = new this<T>((res, rej) => { resolve = res; reject = rej; });
    return { promise, resolve, reject };
  } });
}

// Safari 17.4. PDF.js uses it for its viewer's event listeners.
if (typeof AbortSignal !== 'undefined' && !('any' in AbortSignal)) {
  Object.defineProperty(AbortSignal, 'any', { configurable: true, writable: true, value: function any(signals: Iterable<AbortSignal>) {
    const controller = new AbortController();
    for (const signal of signals) {
      if (signal.aborted) { controller.abort(signal.reason); break; }
      signal.addEventListener('abort', () => controller.abort(signal.reason), { once: true, signal: controller.signal });
    }
    return controller.signal;
  } });
}

// Safari 17.4. PDF.js's worker uses it to trim decoded data. This copies rather than moves the bytes, which is all it needs.
if (!('transferToFixedLength' in ArrayBuffer.prototype)) {
  Object.defineProperty(ArrayBuffer.prototype, 'transferToFixedLength', { configurable: true, writable: true, value: function transferToFixedLength(this: ArrayBuffer, length = this.byteLength) {
    const copy = new ArrayBuffer(length);
    new Uint8Array(copy).set(new Uint8Array(this, 0, Math.min(length, this.byteLength)));
    return copy;
  } });
}

export {};
